'use strict'

module.exports = { version: '9.9.4' }
